import { Stack } from "@similarweb/ui-components/foundations";

import { NewsMetricsTable } from "./components/table/NewsMetricsTable";
import { NewsVolumeOverTime } from "./components/volume-over-time/NewsVolumeOverTime";

export const NewsAlertsMetrics = () => (
    <Stack
        gap="32px"
        padding="0 0 48px"
    >
        <NewsMetricsTable />
        <NewsVolumeOverTime />
    </Stack>
);
